import { gql, useQuery } from '@apollo/client';

type Vars = {
  organizationId: string;
  offset: number;
  limit: number;
  filter?: {
    name: string;
  };
  sortBy?: string;
  projectStatusFilter?: string;
};

type UserProject = {
  id: string;
  name: string;
};

type CurrentUser = {
  id: string;
  userProjects: UserProject[];
  userProjectsCount: number;
};

type Data = {
  currentUser: CurrentUser;
};

const GET_USER_PROJECTS = gql`
  query getUserProjects(
    $organizationId: ID!
    $offset: Int!
    $limit: Int!
    $filter: ProjectFilter
    $sortBy: String!
    $projectStatusFilter: String!
  ) {
    currentUser {
      __typename
      id
      userProjectsCount(
        organizationId: $organizationId
        filter: $filter
        sortBy: $sortBy
        projectStatusFilter: $projectStatusFilter
      )
      userProjects(
        organizationId: $organizationId
        offset: $offset
        limit: $limit
        filter: $filter
        sortBy: $sortBy
        projectStatusFilter: $projectStatusFilter
      ) {
        id
        name
      }
    }
  }
`;

export const useGetUserProjectQuery = ({
  organizationId,
  offset,
  limit,
  filter,
  sortBy = 'name',
  projectStatusFilter = 'active'
}: {
  organizationId: string;
  offset: number;
  limit: number;
  filter?: {
    name: string;
  };
  sortBy?: string;
  projectStatusFilter?: string;
}) =>
  useQuery<Data, Vars>(GET_USER_PROJECTS, {
    variables: {
      organizationId,
      offset,
      limit,
      filter,
      sortBy,
      projectStatusFilter
    }
  });
